module.exports = __webpack_public_path__ + "static/media/combo_6.c69feffe.png";